import router from './router'
import Store from '@/store'

// 按优先级弹
// const upgradeDialogFn = (to)=> {
//   if(!(['403', '404'].includes(to.name))) {
//     if(!Store.state.upgradeDialog) {
//       // 第一次打开
//       Store.commit('SET_UPGRADE_DIALOG_VISIBLE', 1);
//     }else {
//       // 打开全局的新功能推送弹窗（例如：图纸协作）
//       Store.commit('SET_UPGRADE_DRAWING_DIALOG_VISIBLE', 1);
//     }
//   }else {
//     Store.commit('SET_UPGRADE_DIALOG_VISIBLE', 0);
//     Store.commit('SET_UPGRADE_DRAWING_DIALOG_VISIBLE', 0);
//   }
// }



router.beforeEach(async (to, from, next)=> {
  // console.group('路由的to和from以及权限(初始为false)')
  // console.log('to===>',to);
  // console.log('from===>', from);
  // console.log('isPermission===>', Store.state.isPermission);
  // console.groupEnd()
  try {
    document.title = to.meta.title ? `${to.meta.title} - HAIZOL海智智造` : 'HAIZOL海智智造';
  } catch (err) {
    document.title = 'HAIZOL海智智造';
    // 可能是meta不存在或者怎样
    console.error('更改title失败', err);
  }
  if(Store.state.isPermission) {
    next()
  }else {
    try {
      if(to.name !== '403') { //不判断一下会连403页面都被卡住
        const isPermission = await Store.dispatch('checkUserInfo', ()=> {
          if(from.path === '/' && from.matched && from.matched.length === 0) {
            // 是首次进入或刷新页面
            // upgradeDialogFn(to);
          }
        });
        if(isPermission) {
          return next();
        }
        next({path: '/403'})
      }else {
        next()
      } 
    } catch (err) {
      console.error(err);
      next({path: '/403'})
    }
  }
})